import $ from 'jquery';
import Queue from './queue';
import utils from './utils';
import logger from './logger';

/*eslint-disable */
const getQueryString = _getQueryString();
const ua = navigator.userAgent;
var reportQueue = new Queue();

function initReport() {
	if(!window.YA){
		utils.load(process.env.REACT_APP_HOST_REPORT).then(function() {
			reportQueue.run();
			eventBind();
			logger.log('report jssdk load success');
		}).catch(function(res){
			logger.log('report jssdk load error');
		});
	}
}

//页面浏览量，开启心跳
function reportPageView(obj, extParam){
    obj = obj || {};
    extParam = extParam || {};

    window.ya && ya.stopProductHeartbeat();

    var source = {
	        ua: ua,
            pro : obj.pro || "huya_H5",//产品给的
            pas : YA.cookie.get('username') || '',
            yyuid : YA.cookie.get('yyuid') || '',
            pageType : "root",
            rso : getQueryString('channel') || getQueryString('promoter') || getQueryString('from') || "",
            rso_desc : getQueryString('rso_desc') || "",
            eid : "",
            eid_desc : "",
            hasvedio: '0',
            wap_domain: 'wap',
            wid: window._hiido_wid,
            extar:'',
            sguid : YA.cookie.get('guid') || ''
        };

    for(var property in obj){
        source[property] =  obj[property];
    }

    window.ya = new YA(source.pro,source.pas,{
        pageType: source.pageType,
        yyuid : source.yyuid,
        curl: location.href
    });

    if (typeof extParam == 'string') {
        ya.setExtParam(extParam);
    } else if (typeof extParam == 'object'){
        for (var o = 0; o < extParam.length; o++) {
            ya.setExtParam(extParam[o]);
        }
    }

    ya.setExtParam('watchvedio=0');
    ya.reportProductStartUp(source);
    ya.startProductHeartbeat(source);
    ya.reportProductEvent(source);
}

//离开页面，关闭心跳
function stopReportPageView(source){
    window.ya && ya.stopProductHeartbeat(source);
}

//普通上报，点击之类
function report(options){
    let rso = getQueryString('channel') || getQueryString('promoter') || getQueryString('from') || "";
    window.ya &&  window.ya.setExtParam('hasvedio=0&watchvedio=0');
    window.ya &&  window.ya.reportProductEvent({
	    ua: ua,
	    rso: rso, // 渠道上报
        eid: options.eid,  //产品给的
        eid_desc: options.eid_desc,   //产品给的，
	    extra: options.extra || ""
    })
}

function eventBind() {
	//点击上报
	$("body").on( "ontouchstart" in document ? 'touchstart' : 'click', '.clickstat',function(event){
		var parHasVideo = $(this).attr('stat-ext-parma-hasvedio') || 'hasvedio=0',
			parWatchVideo = $(this).attr('stat-ext-parma-watchvedio') || 'watchvedio=0',
			rso= getQueryString('channel') || getQueryString('promoter') || getQueryString('from') || "",
			uid = $(this).attr('data-uid'),//主播Uid
			stat = ($(this).attr('data-stat')|| '').split('|') || [],
			eid = stat[0],
			eid_desc = stat[1],
			statReq = {};//m埋点信息

		if (uid) {
			window.localStorage.setItem('live_room_stat_ref', (eid + uid).split('k/')[1]);
			statReq = {
				ua: ua,
				rso: rso, //渠道号
				eid:eid + '/' + uid,  //产品给的
				eid_desc:eid_desc  +  '/主播uid' //产品给的
			}
		}else{
			statReq = {
				ua: ua,
				rso: rso, //渠道号
				eid:eid,  //产品给的
				eid_desc:eid_desc   //产品给的
			}
		}

		window.ya && ya.setExtParam(parHasVideo + '&' + parWatchVideo);
		window.ya && ya.reportProductEvent(statReq);

	});
}

function _getQueryString( url ){
    var queryObj = parseQueryString();
    return function( key ){
        return queryObj[key] || null;
    };
    function parseQueryString(url) {
        var pos;
        var obj = {};
        url = url || window.location.href;
        if ((pos = url.indexOf("?")) != -1) {
            var param = url.substring(pos+1, url.length)
            var paramArr = param.split('&');
            var keyValue = [];
            for (var i = 0, l = paramArr.length; i < l; i++) {
                keyValue = paramArr[i].split('=');
                obj[keyValue[0]] = keyValue[1];
            }
        }
        return obj;
    }
}

var Report = window.wapReport = {
    report : function(options){
	    initReport();
	    if(window.YA){
		    report(options);
	    }else{
		    reportQueue.add(function(){
			    report(options);
		    })
	    }

    },
    reportPageView: function(obj, extParam) {
	    initReport();
	    if(window.YA){
		    reportPageView(obj, extParam);
	    }else{
		    reportQueue.add(function(){
			    reportPageView(obj, extParam);
		    })
	    }
    },
    stopPageView: function(source){
	    initReport();
	    if(window.YA){
		    stopReportPageView(source);
	    }else{
		    reportQueue.add(function(){
			    stopReportPageView(source);
		    })
	    }

    }
};

export default Report;
/*eslint-enable */


// WEBPACK FOOTER //
// ./src/common/js/report.js